import SpecialInvitationForm from "./SpecialInvitationForm";

export default function EditSpecialInvite({ data, tags }) {
  return <SpecialInvitationForm data={data} tags={tags} />;
}
